const aspectRatios: Record<'mobile' | 'web', Record<string, number>> = {
  web: {
    others: 1903 / 600,
  },
  mobile: {
    others: 70 / 31,
  },
}

export const getCurrentAspectRatio = (isMobile: boolean, route: string) => {
  if (isMobile) {
    return aspectRatios.mobile[route] ? aspectRatios.mobile[route] : aspectRatios.mobile.others
  }
  return aspectRatios.web[route] ? aspectRatios.web[route] : aspectRatios.web.others
}
